export type EnumType<Key extends string> = { [key in Key]: key };

export function createEnum<Key extends string>(values: readonly Key[]): EnumType<Key> {
  return values.reduce((acc, value) => {
    acc[value] = value;
    return acc;
  }, {} as EnumType<Key>);
}

export type EnumValueType<TObject extends Record<string, string>> = TObject[keyof TObject];
